export default __webpack_public_path__ + "static/media/ConnectPlug.c43b11e0.png";